import React, { useState } from 'react'

import GenericModal from '../../../../components/GenericModal'
import Dropdown from '../../../../components/Dropdown'
import CsvMappingUpload from '../../../../components/CsvMappingUpload'
import { useAppDispatch } from '../../../../store'
import { getEnrollmentsApi } from '../../../../store/slices/termsSectionsSlice/api'
import { CreateEnrollment } from '../CreateEnrollment'
import { type ApplyFiltersAndDispatchParams } from '../../../../components/CustomTable/types'
import { useParams } from 'react-router-dom'
import { getTerm } from '../../../../store/slices/termsSlice/selectors'

interface TopbarActionsProps {
  params?: ApplyFiltersAndDispatchParams
}

export const TopbarActions: React.FC<TopbarActionsProps> = ({ params }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const { id } = useParams()
  const term = getTerm()

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
  }

  const uploadApi = (): void => {
    setIsUploadModal(true)
  }

  const addManually = (): void => {
    setIsCreateModal(true)
  }

  const menuItems = [
    { text: 'Upload Enrollments (.csv)', action: uploadApi },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      <Dropdown menuItems={menuItems} label='Add Enrollments' />
      <GenericModal
        isOpen={isCreateModal}
        title={'Create Student Enrollment'}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateEnrollment params={params} handleCloseModal={() => { setIsCreateModal(false) }} />
      </GenericModal>

      <CsvMappingUpload isOpen={isUploadModal} onClose={closeUploadModal} modalTitle="Student Enrollments" csvHeaderEndpoint="/api/users/roles/csv_headers" uploadCsvEndpoint={`/api/users/roles/?is_student=True&term_id=${term?.termId}`} onSuccess={() => { void dispatch(getEnrollmentsApi({ urlId: id, params: { pageSize: 15 } })) }} />

    </>
  )
}
